<template>
  <div class="content">
    <div class="page-inner">
      <section class="scrollable">
        <div class="card">
          <div class="card-body">
            <div class="p-1 pos-rlt">
              <div class="float-left">
                <h2 class="text-dark strong mb-0">{{ $t('my_campaigns') }}</h2>
                <h4 class="mt-0">{{ $t('you_have') }} <span class="strong text-warning">{{ credits }} {{ $t('credits') }}</span> {{$t('to_spend')}}.</h4>
              </div>
              <div class="float-right">
                <router-link to="/user/campaigns/create" class="btn btn-primary">
                  <span>
                    {{ $t('create_campaign') }}<i class="fas fa-plus ml-2"></i>
                  </span>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <section class="p-1 mt-2">
          <p class="mt-2 p-1" v-if="!loading && !campaigns.length">
            {{ $t('dont_have_campaigns_yet') }}
          </p>
          <p class="h4 text-dark strong mt-1" v-if="activeCampaigns.length">
            {{ $t('active_campaigns') }}
          </p>
          <div class="card mb-2" v-for="(item) in activeCampaigns" v-bind:key="item._id">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="clearfix">
                    <div class="float-left">
                      <div class="strong text-danger">{{ $t('boost_campaign') }}</div>
                      <div>{{ $t('put_campaign_top') }}</div>
                      <div>
                        <b>{{ item.credits }}</b> {{ $t('credits_left')}}.
                      </div>
                    </div>
                    <div class="float-right">
                      <button type="button" class="btn btn-icon btn-round btn-danger" @click="boostCampaign(item)">
                        <i class="fa fa-bolt"></i>
                      </button>
                    </div>
                  </div>

                </div>
              </div>
              <div class="mt-4">
                <div class="text-danger" v-if="item.artist && item.artist.name">{{ item.artist.name }}</div>
                <div>
                  <a :href="item.url" target="_blank">
                    {{ item.url }}
                  </a>
                </div>
                <div class="mb-2">
                  <div>
                    <small><b>{{ $t('genre') }}:</b> {{ item.main_genre }}</small>
                  </div>
                </div>
                <span class="badge badge-primary" v-if="item.type == 'facebook_follow'">Facebook Artist</span>
                <span class="badge badge-danger" v-if="item.type == 'youtube_sub'">YouTube Subscription</span>
                <span class="badge badge-success text-dark" v-if="item.type == 'spotify_follow_artist'">Spotify Artist</span>
                <span class="badge badge-success text-dark" v-if="item.type == 'spotify_follow_playlist'">Spotify Playlist</span>
                <span class="badge badge-warning" v-if="item.type == 'soundcloud_follow'">SoundCloud Profile</span>
              </div>
              <div class="mt-4">
                <div class="clearfix">
                  <button type="button" class="btn btn-default btn-border float-left" @click="item.showInteractions = !item.showInteractions" :class="{ active: item.showInteractions }">
                    <i class="fa fa-table m-r-xs"></i> {{ $t('view_interactions') }} <span class="text-danger strong">({{ item.users_clicked.length || 0 }})</span>
                  </button>
                  <button type="button" class="float-right btn btn-default btn-border" @click="removeCampaing(item)">
                    <i class="fa fa-trash text-danger"></i>
                  </button>
                </div>
              </div>
              <div class="users-table-container mt-2" v-if="item.showInteractions">
                <table class="table b-light table-striped mb-0" v-if="item.users_clicked.length">
                  <thead>
                    <tr>
                      <th>{{ $t('user') }}</th>
                      <th>{{ $t('country') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="user in item.users_clicked" v-bind:key="user._id + Math.random()">
                      <td>
                        {{user.name || user.username}}
                      </td>
                      <td>
                        <img class="mr-2" width="24" :src="'../../static/img/countries/' + user.country + '.png'" :alt="user.country" onerror="$(this).hide()">{{ user.country }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <p class="h4 strong text-dark mt-5" v-if="completedCampaigns.length">
            {{ $t('completed_campaigns') }}
          </p>
          <div class="card mb-2" v-for="(item) in completedCampaigns" v-bind:key="item._id">
            <div class="card-body">
              <div>
                <div class="text-danger" v-if="item.artist && item.artist.name">{{ item.artist.name }}</div>
                <div>
                  <a :href="item.url" target="_blank">
                    {{ item.url }}
                  </a>
                </div>
                <div class="mb-2">
                  <div>
                    <small><b>{{ $t('genre') }}:</b> {{ item.main_genre }}</small>
                  </div>
                </div>
                <span class="badge badge-primary" v-if="item.type == 'facebook_follow'">Facebook Artist</span>
                <span class="badge badge-danger" v-if="item.type == 'youtube_sub'">YouTube Subscription</span>
                <span class="badge badge-success" v-if="item.type == 'spotify_follow_artist'">Spotify Artist</span>
                <span class="badge badge-success" v-if="item.type == 'spotify_follow_playlist'">Spotify Playlist</span>
                <span class="badge badge-warning" v-if="item.type == 'soundcloud_follow'">SoundCloud Profile</span>
              </div>
              <div class="mt-4">
                <div class="clearfix">
                  <button type="button" class="btn btn-dark btn-border float-left text-dark" @click="item.showInteractions = !item.showInteractions" :class="{ active: item.showInteractions }">
                    <i class="fa fa-table m-r-xs"></i> {{ $t('view_interactions') }} <span class="text-danger strong">({{ item.users_clicked.length || 0 }})</span>
                  </button>
                </div>
              </div>
              <div class="users-table-container mt-2" v-if="item.showInteractions">
                <table class="table b-light table-striped mb-0" v-if="item.users_clicked.length">
                  <thead>
                    <tr>
                      <th>{{ $t('user') }}</th>
                      <th>{{ $t('country') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="user in item.users_clicked" v-bind:key="user._id + Math.random()">
                      <td>
                        {{user.name || user.username}}
                      </td>
                      <td>
                        <img class="mr-2" width="24" :src="'../../static/img/countries/' + user.country + '.png'" :alt="user.country" onerror="$(this).hide()">{{ user.country }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
        <div class="mb-lg-4 wrapper-lg"></div>
      </section>
    </div>
  </div>
</template>
<script>

import _ from 'underscore'

export default {
  data: function () {
    return {
      credits: 0,
      defaultImage: 'https://indiefy.net/img/img-placeholder.jpg',
      loading: true,
      campaigns: []
    }
  },
  computed: {
    activeCampaigns: function () {
      return _.filter(this.campaigns, item => item.credits)
    },
    completedCampaigns: function () {
      return _.filter(this.campaigns, item => !item.credits)
    }
  },
  methods: {
    boostCampaign (item) {
      this.$http.post(`${window.apiURL}api/user/campaigns/${item._id}/boost`, null, { withCredentials: true }).then(response => {
        this.$notify({ message: this.$t('campaign_is_now_top') }, 'success', 'fa-check')
        this.$eventBus.$emit('updateCredits')
      }, () => {
        this.$notify({ message: this.$t('no_enough_credits') }, 'warning', 'fa-exclamation')
        this.$eventBus.$emit('updateCredits')
      })
    },
    removeCampaing (item) {
      window.swal({
        title: this.$t('are_you_sure'),
        text: this.$t('remove_campaign_warning'),
        closeOnEsc: false,
        closeOnClickOutside: false,
        icon: 'warning',
        buttons: {
          cancel: {
            text: this.$t('cancel'),
            className: 'btn btn-dark',
            visible: true
          },
          remove: {
            text: this.$t('remove'),
            className: 'btn btn-success'
          }
        }
      }).then((remove) => {
        if (remove) {
          item.disabled = true
          this.$http.delete(`${window.apiURL}api/user/campaigns/${item._id}`, { withCredentials: true }).then(response => {
            this.getCampaigns()
            this.getCredits()
            this.$eventBus.$emit('updateCredits')
            this.$notify({ message: this.$t('campaign_removed') }, 'success', 'fa-check')
          })
        }
      })
    },
    getCampaigns () {
      this.$http.get(`${window.apiURL}api/user/campaigns`, { withCredentials: true }).then(response => {
        this.loading = false
        _.each(response.data, item => {
          item.showInteractions = false
        })

        this.campaigns = response.data
      })
    },
    getCredits () {
      this.$http.get(`${window.apiURL}api/user/credits`, { withCredentials: true }).then(response => {
        this.credits = response.data.available || 0
      })
    }
  },
  created () {
    this.getCampaigns()
    this.getCredits()
  }
}
</script>
<style scoped>
.users-table-container {
  max-height: 200px;
  overflow: auto;
}

.icon-plus-center {
  position: absolute;
  top: 12px;
  right: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/UserCampaigns.vue